const seoConfig = {
  "/": {
    title: "CLIF AI – Advance Your Career with AI & Mentorship",
    description:
      "Upskill, plan your future, and succeed with CLIF AI’s smart tools and personalized mentorship. Start your growth journey today.",
    keywords:
      "career advancement, AI career tools, personalized mentorship, skill development, professional growth, job success, CLIF AI",
  },
  "/about-us": {
    title: "About CLIF AI – AI-Powered Career Platform",
    description:
      "CLIF AI blends artificial intelligence with expert mentorship to guide your career advancement and professional success.",
    keywords:
      "CLIF AI, about career platform, AI mentorship, professional development, career tools, job success",
  },
  "/dream-career": {
    title: "Find Your Dream Career | CLIF AI Career Planner",
    description:
      "Discover the perfect career path using CLIF AI’s personalized insights, skill maps, and expert mentoring.",
    keywords:
      "dream career, career pathfinder, AI insights, career planner, mentorship, CLIF AI, skill building",
  },
  "/subscription": {
    title: "CLIF AI Pricing – Affordable Growth Plans",
    description:
      "Choose from flexible pricing plans for AI-driven career tools, mentorship, and upskilling to achieve your goals.",
    keywords:
      "CLIF AI pricing, career plans, growth tools, mentorship packages, skill development, job readiness",
  },
  "/for-recruiters": {
    title: "Recruit Smart with CLIF AI – AI Tools for Hiring",
    description:
      "Streamline your hiring process with CLIF AI. Find top talent using AI-powered skill matching and insights.",
    keywords:
      "AI hiring tools, recruiter solutions, talent acquisition, skill matching, recruitment software, CLIF AI",
  },
  "/post-job": {
    title: "Post a Job | Hire with AI-Powered Tools – CLIF AI",
    description:
      "Quickly post jobs and connect with top talent using CLIF AI’s intelligent hiring platform.",
    keywords:
      "post job, AI recruitment, job board, smart hiring, CLIF AI, find candidates, recruitment tools",
  },
  "/contact": {
    title: "Contact CLIF AI – Get in Touch Today",
    description:
      "Have questions? Contact CLIF AI for support, partnerships, or to explore how we can help your career journey.",
    keywords:
      "contact CLIF AI, career support, inquiry, AI guidance, mentorship, skill development, get in touch",
  },
  "/individuals": {
    title: "Career Growth for Individuals | CLIF AI Tools & Mentorship",
    description:
      "Empower your career with AI-based insights, skill development, and expert mentoring tailored to your journey.",
    keywords:
      "individual career growth, AI career tools, learning platform, mentorship, CLIF AI, upskilling",
  },
  "/institutions": {
    title: "AI Career Solutions for Institutions | CLIF AI",
    description:
      "Enable your students and staff to grow with AI-powered career tools, upskilling programs, and mentorship support.",
    keywords:
      "career solutions, institutions, universities, organizations, talent development, AI platform, mentorship, CLIF AI",
  },
  "/*": {
    title: "CLIF AI – Career Growth with AI Insights & Mentorship",
    description:
      "Explore CLIF AI’s full platform offering AI career tools, mentorship, and upskilling resources for every stage.",
    keywords:
      "career growth platform, AI tools, skill building, mentorship, CLIF AI, job readiness, professional development",
  },
  "/coming-soon": {
    title: "Coming Soon | CLIF AI Features for Career Success",
    description:
      "We’re building something amazing! New AI-powered features launching soon to boost your career potential.",
    keywords:
      "coming soon, CLIF AI features, career success, future tools, AI development, mentorship, upskilling",
  },
  "/privacy-policy": {
    title: "Privacy Policy | CLIF AI Data Protection & Security",
    description:
      "Learn how CLIF AI safeguards your personal information while delivering personalized career solutions.",
    keywords:
      "privacy policy, data protection, user security, CLIF AI, AI career platform, confidentiality, information safety",
  },
  "/terms-use": {
    title: "Terms of Use | CLIF AI Career Platform Guidelines",
    description:
      "Read the terms and conditions for using CLIF AI’s career development tools, mentorship services, and AI resources.",
    keywords:
      "terms of use, CLIF AI, user agreement, legal policy, AI career tools, service guidelines",
  },
  "/login": {
    title: "Login | Access Your CLIF AI Dashboard",
    description:
      "Sign in to your CLIF AI account to access personalized career guidance, mentorship, and learning tools.",
    keywords:
      "CLIF AI login, user dashboard, access account, career insights, mentorship, skill development",
  },
  "/signup": {
    title: "Sign Up | Join CLIF AI for Career Growth",
    description:
      "Create your CLIF AI account to start your career journey with AI-driven tools, learning, and mentorship.",
    keywords:
      "signup, register, CLIF AI account, start career journey, upskilling, AI tools, job growth",
  },
  "/recruiterslogin": {
    title: "Recruiter Login | CLIF AI Talent Solutions",
    description:
      "Recruiters, sign in to manage job postings, assess candidates, and streamline hiring using AI-driven tools.",
    keywords:
      "recruiter login, CLIF AI hiring, job dashboard, talent solutions, recruitment tools, AI assessments",
  },
  "/organizationlogin": {
    title: "Organization Login | Talent Growth with CLIF AI",
    description:
      "Organizations can log in to CLIF AI to manage talent development programs, mentorship initiatives, and training.",
    keywords:
      "organization login, talent development, upskilling platform, mentorship, CLIF AI, institutional login",
  },
};

export default seoConfig;
